// @ts-check
/**
 * @enum {string}
 */
export const fontSizes = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});

/**
 * @enum {string}
 */
export const fontWeights = Object.freeze({
  normal: 'normal',
  bold: 'bold',
  lighter: 'lighter'
});

/**
 * @enum {string}
 */
export const fontStyles = Object.freeze({
  normal: 'normal',
  italic: 'italic'
});

